// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"59":"434f5672","488":"6f5428ca","725":"8c14def8"}[chunkId] + ".chunk.js");